:root {
  --color-light-bg: #FFFFDD; /* jaune clair */
  --color-dark-bg: #920129; /* Bleu foncé */
  --color-light-text: #FFFFBB;
  --color-dark-text: black;

  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
